import * as React from "react";


export class Forbidden extends React.Component<{}, {}> {

    render() {
        return (
            <div className="middle-box text-center fadeInDown">
                <h1>403</h1>
                <h2 className="font-bold danger">Access Denied</h2>

                <div className="error-desc">
                    You don't have access to this page/action. If you should have access please contact administrator
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/error/Forbidden.tsx